import createReducer from '../createReducer'
import { FETCH_ACTIVITY_TYPES_SUCCESS } from './constants'

export const initialState = {
  types: [],
}

export default createReducer(initialState, {

  [FETCH_ACTIVITY_TYPES_SUCCESS]: (state, action) => {
    return { ...state, types: action.payload.data._embedded.activity_types }
  },

})
